export default __webpack_public_path__ + "static/media/Download_icon.e7497fd9.svg";